import { takeLatest, call, put, all } from "redux-saga/effects";
import * as types from "./types";
import { setSubclientsData } from "./actions";
import api from "app/services/api";
import objectToQueryString from "app/utils/objectToQueryString";
import ToastService from "../../../services/ToastService";

export function* create({ payload }) {
  const { formData, callback } = payload;
  try {
    yield put({
      type: types.CREATE,
    });
    yield call(api.post, "/subclients", formData);
    yield put({
      type: types.CREATE_SUCCESS,
    });
    ToastService.showSuccess("subclientsList.successCreate");
    callback();
  } catch (error) {
    ToastService.showApiRequestError(error);
    yield put({
      type: types.CREATE_FAIL,
    });
  }
}

export function* read({ payload }) {
  try {
    yield put({
      type: types.READ,
    });
    const { data } = yield call(
      api.get,
      `/subclients${objectToQueryString(payload)}`
    );
    yield put(setSubclientsData(data));
    yield put({
      type: types.READ_SUCCESS,
    });
  } catch (error) {
    yield put({
      type: types.READ_FAIL,
    });
  }
}

export function* update({ payload }) {
  const { id, formData, callback } = payload;
  try {
    yield put({
      type: types.UPDATE,
    });

    const { apiKey } = formData;

    if (apiKey) {
      yield call(api.put, `/apikeys/${apiKey.id}`, { api_key: apiKey.api_key });
    }

    yield call(api.put, `/subclients/${id}`, formData);
    yield put({
      type: types.UPDATE_SUCCESS,
    });
    ToastService.showSuccess("subclientsList.successUpdate");
    callback();
  } catch (error) {
    ToastService.showApiRequestError(error);
    yield put({
      type: types.UPDATE_FAIL,
    });
  }
}

export function* inactivate({ payload }) {
  const { id, callback } = payload;
  try {
    yield put({
      type: types.DELETE,
    });
    yield call(api.delete, `/subclients/${id}`);
    yield put({
      type: types.DELETE_SUCCESS,
    });
    ToastService.showSuccess("subclientsList.successInactivate");
    callback();
  } catch (error) {
    ToastService.showApiRequestError(error);
    yield put({
      type: types.DELETE_FAIL,
    });
    callback();
  }
}

export function* updateApiKey({ payload }) {
  try {
    const { id, api_key } = payload;
    yield call(api.put, `/apikeys/${id}`, { api_key });
  } catch (error) {
    ToastService.showApiRequestError(error);
  }
}

export default all([
  takeLatest(types.REQUEST_CREATE, create),
  takeLatest(types.REQUEST_READ, read),
  takeLatest(types.REQUEST_UPDATE, update),
  takeLatest(types.REQUEST_DELETE, inactivate),
  takeLatest(types.REQUEST_UPDATE_SUBCLIENT_API_KEY, updateApiKey),
]);
